// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-item-action-buttons {
  display: flex;
  gap: var(--spacing-regular);
}
.cart-item-action-buttons .delete-action {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}
.cart-item-action-buttons .delete-action .vert-icon {
  font-size: var(--font-medium);
}
.cart-item-action-buttons .delete-action .vert-icon svg {
  fill: var(--color-detached);
  width: 20px;
  height: 20px;
}
.cart-item-action-buttons .delete-action .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 600;
  color: var(--color-detached) !important;
  line-height: var(--font-paragraph-line) !important;
  margin-left: var(--spacing-extra-small);
}
.cart-item-action-buttons .favorite-action .vert-paragraph {
  color: var(--color-detached) !important;
}
.cart-item-action-buttons .favorite-action .vert-icon:not(.icon-favorited) svg {
  fill: var(--color-detached) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Cart/CartItemActionButtonsStyles.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,2BAAA;AACJ;AAHA;EAKQ,aAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;AACR;AATA;EAWY,6BAAA;AACZ;AAZA;EAagB,2BAAA;EACA,WAAA;EACA,YAAA;AAEhB;AAjBA;EAoBY,gCAAA;EACA,gBAAA;EACA,uCAAA;EACA,kDAAA;EACA,uCAAA;AAAZ;AAxBA;EA8BY,uCAAA;AAHZ;AA3BA;EAkCgB,sCAAA;AAJhB","sourcesContent":[".cart-item-action-buttons {\n    display: flex;\n    gap: var(--spacing-regular);\n\n    .delete-action {\n        display: flex;\n        align-items: center;\n        margin: 0;\n        padding: 0;\n\n        .vert-icon {\n            font-size: var(--font-medium);\n            svg {\n                fill: var(--color-detached);\n                width: 20px;\n                height: 20px;\n            }\n        }\n\n        .vert-paragraph {\n            font-size: var(--font-paragraph);\n            font-weight: 600;\n            color: var(--color-detached) !important;\n            line-height: var(--font-paragraph-line) !important;\n            margin-left: var(--spacing-extra-small);\n        }\n    }\n\n    .favorite-action {\n        .vert-paragraph {\n            color: var(--color-detached) !important;\n        }\n        .vert-icon:not(.icon-favorited) {\n            svg {\n                fill: var(--color-detached) !important;\n            }\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
